import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import React, { useEffect, useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import PriceBooksModalContent from "./ModalContent/PriceBooksModalContent";
import { useLocation } from "react-router-dom";
import { useGETPriceBookList, useUpdateMultiplePriceBookLines } from "./usePriceBook";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { useBrandList } from "./hooks/useProductCatalogue";
import { useCategoryParentID } from "./useProduct";
import { showToast } from "../../utils/toastUtils";


const PricebookByDiv = () => {
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editedRows, setEditedRows] = useState<any[]>([]);
  const [inputSearch,setInputSearach] = useState<string>('')
  
  const [savePriceBookLine,setSavePriceBookLine] = useState<any>(
    {
      LineId:0,
      category:'',
      product:'',
      enable:false,
      search:'',
      Brnad:'',
      Name_SKU_Code_Tag:'',
      MaxRetailPrice:0,
      SellingPrice:0,
      Created_On:'',
      Last_Modified_on:'',
    }
  )


  const location = useLocation();
  const brand = location.state?.brand || null; 
  console.log("Brand from location state   IDDD:", brand.id); 
  
  const priceBooksDataColumns = (handleInputChange:(id:number,field:string,value:string ) =>void)=>[
  
    
    {
      name: "Brand",
      selector: (row: { Brand: number | string }) => row.Brand,
      sortable: true,
      // width: "270px",
      wrap:true 
    },
    {
      name: "Category",
      selector: (row: { category: number | string }) => row.category,
      sortable: true,
      width: "150px",
      wrap:true 
    },
    {
      name: "Product",
      selector: (row: { product: string }) => row.product,
      sortable: true,
      wrap: true,
      // maxWidth:'200px',
      width: "270px",

    },

      {
      name: "Name | SKU Code | Tag",
      selector: (row: { Name_SKU_Code_Tag: number | string }) => row.Name_SKU_Code_Tag,
      sortable: true,
      width: "270px",
      wrap:true 
    },
    
    {
      name: "MRP",
      width: "200px",
      cell:(row:any)=>(
         
         <input 
          type="number"
          style={{maxWidth:80,height:30}}
          // value={row.mrp}
       
            value={row.MaxRetailPrice}   
            onChange={(e) => {
                
              const input  = Number(e.target.value);
              if(input>-1){
                handleInputChange(row, 'MaxRetailPrice', String(input))
              }else{
                showToast.warning('MRP Can not be negative')
              }
            
            }}
         />
      )
    },

    // {
    //   name: "MRP",
    //   selector: (row: { MaxRetailPrice: number | string }) => row.MaxRetailPrice,
    //   sortable: true,
    //   width: "90px",
    //   wrap:true 
    // },
    
    // {
    //   name: "Selling Price",
    //   selector: (row: { SellingPrice: number | string }) =>row.SellingPrice,
    //   sortable: true,
    //   width: "150px",
    //   wrap:true 
    // },




    {
      name: "Selling Price",
      width: "200px",
        cell:(row:any)=>(
       <input
        style={{maxWidth:80,height:30}}
        type="number"
        value={row.SellingPrice} 

        onChange={(e)=>{
           const input = Number(e.target.value);
          if(input >-1){
            handleInputChange(row,'SellingPrice',String(input))
          }else{
            showToast.error('Price can not be negative')
          }
        }}
       />
      )
    },

    {
      name: "Created At",
      selector: (row: { Created_On: number | string }) => row.Created_On,
      sortable: true,
      width: "150px",
      wrap:true 
    },
    {
      name: "Last Modified On",
      selector: (row: { Last_Modified_on: number | string }) => row.Last_Modified_on,
      sortable: true,
      width: "170px",
      wrap:true 
    },
   {
    name:'Enable',
      // width: "300px",
      cell:(row:any)=>(
      <input 
        type="checkbox"
        checked={!!row.enable}
        onChange={(e:any)=>handleInputChange(row,'enable',e.target.checked)}
      />
    )
   }
  ];
  
   const ID:number = brand?.id ?? undefined
   
  const [BrandFromSearchTerm, setBrandFromSearchTerm] = useState(""); // ✅
  const [BrandPage,setBrandPage] = useState(1); 
  const [BrandFromHasMore, setBrandFromHasMore] = useState(true);
  const [BrnadOptions, setBrnadOptions] = useState<any[]>([]); // paginated options
  

   const [filtersStateBrand, setFiltersStateBrand] = useState<any>({
    page:1,
    length:10,
    Brandid:'',
    CategoryId:'',
   })
   
 
    const [filterData, setFilterData] = useState<any>({
    page: 1, 
    limit: 10,
    orgUnit:null
    });


  /// BrandList Options API
 const { data: BrandList,isLoading:BrandLoading } = useBrandList({
    params: {
      // start:filtersStateBrand.start,
      start:BrandPage,
      length:filtersStateBrand.length,
      search:BrandFromSearchTerm 
    },
    enable:true
  });

   //API
   const{mutate:updateMultiplePriceBook} = useUpdateMultiplePriceBookLines()
   const {data:CategoryParentId} = useCategoryParentID({enable:true})
   
   const { data, isLoading, isSuccess } = useGETPriceBookList({
    enable: true,
    id: ID,
    page: filterData.page,
    limit:filterData.limit,
    ...(inputSearch ==""?{}:{search:inputSearch}),
    ...(Number(filtersStateBrand.Brandid) !== 0 && { brand_id: Number(filtersStateBrand.Brandid) }),
    ...(Number.isNaN(Number(filtersStateBrand.CategoryId)) ||Number(filtersStateBrand.CategoryId) == 0 ?{}:{category_id:Number(filtersStateBrand.CategoryId)} )
  });
  
    useEffect(() => {
      if (!isLoading && isSuccess) {
        const tableData = data?.data?.data?.map((item: any) => ({
          LineId: item.LineId,
          category: item.Category,
          product: item.ProductName,
          productId: item.ProductId,
          enable:item.Enabled,
          Brand:item.BrandName ||'-',
          Name_SKU_Code_Tag:item?.ProductName || '-',
          MaxRetailPrice:item.MaxRetailPrice || '-',
          SellingPrice:item.SellingPrice || '-',
        
          Created_On:item?.CreatedAt ? item?.CreatedAt.date.split('.')[0] : '-',
          Last_Modified_on:item?.UpdatedAt? item?.UpdatedAt.date.split('.')[0]:'-',
        
        }));

        setSavePriceBookLine(tableData);
      }
    }, [isLoading, isSuccess, data]);
 
      
    useEffect(()=>{
      setBrnadOptions([]);
      setBrandPage(1);
      setBrandFromHasMore(true);
    },[BrandFromSearchTerm]);
   
    useEffect(()=>{
      
     const formatedDataForBrandFilter = Array.isArray(BrandList?.data?.data)?
     BrandList?.data?.data.map((item:any)=>({
      id:item.BrandId,
      label:item.BrandName
      
     })):[]

     setBrnadOptions((prev)=>{
      const updated = [...prev, ...formatedDataForBrandFilter]
      const hasAll = updated.some((item) => item.id === "");
      const withoutAll = updated.filter((item) => item.id !== "");

      return hasAll
        ? [{ id: "", label: "All" }, ...withoutAll]
        : [{ id: "", label: "All" }, ...withoutAll];
     })
     if(formatedDataForBrandFilter.length<10){
      setBrandFromHasMore(false);
     }

    },[BrandList])
  
  const formatedCategoryParentData = [
  { id:'All', label: 'All' },
  ...Object.entries(CategoryParentId?.data?.CategoryParentId || {}).map(
    (item:any, label:any) => ({
      id:item[0],
      label:item[1],
    })
  ),
]; 

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
   
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const handleClose = () => setIsModalOpen(false);

  // const handleInputChange = (row: any, field: string, value: any) => {

  //   setEditedRows((prev) => {
  //     const existingRowIndex = prev.findIndex((item) => item.ProductId === row.productId);
      
  //     if (existingRowIndex !== -1) {
  //       // If already edited before, update the existing entry
  //       const updatedRows = [...prev];        
  //       updatedRows[existingRowIndex] = {...updatedRows[existingRowIndex],[field]: value,};

  //       return updatedRows;
  //     } else {
  //       // If first time editing, add a new entry
  //       return [
  //         ...prev,
  //         {
  //           ProductId: row.productId,
  //           MaxRetailPrice: field === 'MaxRetailPrice' ? value : row.MaxRetailPrice,
  //           sellingprice: field === 'SellingPrice' ? value : row.SellingPrice,
  //           enable: field === 'enable' ? value : row.enable,
  //           LineId: row.LineId ?? -1, 
  //         },
  //       ];  
  //     } 
  //   });
  // };

  const handleInputChange = (row: any, field: string, value: any) => {
  // update the table data so UI reflects changes immediately
  setSavePriceBookLine((prev:any) =>
    prev.map((item:any) =>
      item.productId === row.productId
        ? { ...item, [field]: value }
        : item
    )
  );

  // keep track of edited rows separately for API submission
  setEditedRows((prev) => {
    const existingRowIndex = prev.findIndex((item) => item.ProductId === row.productId);

    if (existingRowIndex !== -1) {
      // update existing entry
      const updatedRows = [...prev];
      updatedRows[existingRowIndex] = {
        ...updatedRows[existingRowIndex],
        [field]: value,
      };
      return updatedRows;
    } else {
      // add new entry
      return [
        ...prev,
        {
          ProductId: row.productId,
          MaxRetailPrice: field === 'MaxRetailPrice' ? value : row.MaxRetailPrice,
          SellingPrice: field === 'SellingPrice' ? value : row.SellingPrice,
          enable: field === 'enable' ? value : row.enable,
          LineId: row.LineId ?? -1,
        },
      ];
    }
  });
};


















  
  const updateMultiplePriceBookHandler = ()=>{
    // console.log('Edited Rows:', editedRows);

    const ReqBody = {
        data: editedRows.map((row) => ({

        ProductId: row.ProductId,
        MaxRetailPrice: Number(row.MaxRetailPrice),
        SellingPrice: Number(row.SellingPrice),
        Enabled: row.enable === 0 ? false : true,
        LineId: row.LineId, 

      })),
   }
  //  console.log('ReqBody------>',ReqBody);

    updateMultiplePriceBook({ReqBody,id:ID})
    // setEditedRows([]); // Clear the edited rows after saving

  }

 const handlePagination = (pageNo: number) => {
    setFilterData((prev: any) => ({
      ...prev,
      page: pageNo,
    }));
  };

  const handleChangeRowPerPage = (limit: any, pageNo: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      page: pageNo,
      limit: limit,
    }));
  };
  // const handleSearch = (e:any) => {
  //   const searchValue = e.target.value;
  //   console.log('Search Value:', searchValue);
  
  //   setSavePriceBookLine((prev: any) => ({
  //     ...prev,
  //     search: searchValue,
  //   }));
  // };

  const handleFilter = (key: any, selected: any) => {
    setFiltersStateBrand((prev: any) => ({
      ...prev,
      [key]:
        selected.id === "null"
          ? null
          : key === "Brandid"
          ? Number(selected.id)
          : selected.id, // Keep as string for other keys like 'orderStatus'
    }));
  };
  const onLoadMoreBrnads = ()=>{
         if(!BrandLoading && BrandFromHasMore){
               setBrandPage((prev)=>prev+1);
         }
   }


  return (
    <div className="p-2">
      <PageHeader
        title="Price books"
        buttons={[
          // Currently not using in panel (discussion)
          {
            label: "Save",
            onClick:updateMultiplePriceBookHandler,
            color: "#2e8dd3",
          },
          {
            label: "Excel",
            onClick: () => alert("Action 2 clicked"),
            color: "#43B9B2",
          },
          {
            label: "CSV",
            onClick: () => alert("Action 3 clicked"),
            color: "#43B9B2",
          },
        ]}
      />

      <BasicDataTable
       search={true}
        paginationTotalRows={data?.data?.total_records}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(limit: any, pageNo: any) => {
          handleChangeRowPerPage(limit, pageNo);
        }}

       handleSearch={(e:any)=>setInputSearach(e)}
        Title="Price Book Lists"
        data={!isLoading && isSuccess && savePriceBookLine || []}
        showSpinner={isLoading}
        columns={priceBooksDataColumns(handleInputChange)}
        headerContent={
          <>
           <div style={{ marginLeft: 10,}}>
                      <RoundedDropdown
                        options={BrnadOptions}
                        onSelect={(e) => {
                          handleFilter("Brandid", e);
                        }}
                        onSearch={(val) => setBrandFromSearchTerm(val)} // ✅
                        onLoadMore={onLoadMoreBrnads}
                        defaultLabel="All"
                        width="auto"
                        isShowHeading
                        DropdownHeading="Brand"
                        headingColor="#2e8dd3"
                        loading={BrandLoading}
                      />
                    </div>
          {/*
         orgUnitsList={[]} 
         setFiltersState={""}
         DropdownHeading="Brand"
         handleFilterObjectKey =""
         /> */}
         


    <div style={{ marginRight:10,}}>
                      <RoundedDropdown
                        options={formatedCategoryParentData}
                        onSelect={(e:any) => {
                          handleFilter("CategoryId",e);
                        }}
                        // onSearch={(val) => setBrandFromSearchTerm(val)} // ✅
                        // onLoadMore={onLoadMoreBrnads}
                        defaultLabel="All"
                        width="auto"
                        isShowHeading
                        DropdownHeading="Category"
                        headingColor="#2e8dd3"
                        // loading={BrandLoading}
                      />
        </div>
          </>
        }
      />
      <RouteModal
        isOpen={isModalOpen}
        title="Add Price Books"
        size="md"
        content={<PriceBooksModalContent handleClose={handleClose} handleSubmit={handleSubmit}/>}
      />
    </div>
  );
};

export default PricebookByDiv;
